export const ADMIN_INITIATE_ITEMS = 'ADMIN_INITIATE_ITEMS';
export const ADMIN_ADD_COUPON = 'ADMIN_ADD_COUPON';
export const ADMIN_INVOICE_CHANGED = 'ADMIN_INVOICE_CHANGED';

export const ADMIN_SUBSCRIPTION_SEND = 'ADMIN_SUBSCRIPTION_SEND';
export const ADMIN_SUBSCRIPTION_SEND_SUCCESS = 'ADMIN_SUBSCRIPTION_SEND_SUCCESS';